import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { totalBetsSliceActions } from '../../../modules/totalBet/slice';
import { CMDScTotalBetFishprawncrab, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';
import { FishPrawnCrabTotalBet } from '@/models/games/fishprawncrab';

export class CMDScTotalBetFishPrawnCrabHandler extends AbstractHandler {
    _command: CMDScTotalBetFishprawncrab;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScTotalBetFishprawncrab;
    }
    override handle(dispatch: Dispatch<AnyAction>): void {
        const TotalBet = {} as FishPrawnCrabTotalBet;
        const HostId = this._command.Total.HostID;
        let totalPlayerCount = 0;
        TotalBet.Fish = this.convertBetAmount(this._command.Fish);
        TotalBet.Calabash = this.convertBetAmount(this._command.Calabash);
        TotalBet.Tiger = this.convertBetAmount(this._command.Tiger);
        TotalBet.Crab = this.convertBetAmount(this._command.Crab);
        TotalBet.Prawn = this.convertBetAmount(this._command.Prawn);
        TotalBet.Rooster = this.convertBetAmount(this._command.Rooster);
        TotalBet.AnyTripleColor = this.convertBetAmount(this._command.AnyTripleColor);
        TotalBet.AnyTripleSymbol = this.convertBetAmount(this._command.AnyTripleSymbol);
        for (const ba of Object.values(TotalBet)) {
            totalPlayerCount += ba.BetPlayerCount;
        }
        TotalBet.Total = {
            Amount: this._command.Total.Amount,
            BetPlayerCount: totalPlayerCount,
        };
        dispatch(totalBetsSliceActions.update({ HostId, TotalBet }));
    }
}
